<template>
    <div class="subscription-curiculum-view flex-between-wrapper">
      <img class="feature-image" src="/assets/app/class/curiculum-frame-bg.png">
      <div class="premium-curiculum-view">
        <h3 class="view-title">Know where each student stands, every step of the way.</h3>
        <p class="view-description">Track individual student and class performance in real-time. View progress reports by Lexile level, Curriculum standard, and Grade level. Easily export data to a CSV for even more insights!</p>
        <div class="button-wrapper">
          <primary-button @click="handleClickPlan">Choose your plan</primary-button>
        </div>
      </div>
    </div>
</template>

<script>

import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-curiculum-view {
  padding: 96px 0;
  .feature-image {
    margin-top: -20px;
    margin-right: 10px;
  }
  .premium-curiculum-view {
    max-width: 397px;
  }
  @media(max-width: 900px) {
    display: block;
    .feature-image {
      margin-right: 0;
    }
    .premium-curiculum-view {
      max-width: none;
      margin-top: 20px;
    }
  }
  @media(max-width: 767px) {
    padding: 50px 0;
  }
}
</style>
